import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { environment } from '../../../../environment';
import { AuthService } from '@common/services/AuthService/AuthService';
import { EmployeeDetails } from '@common/models/employeeDetails.model';
import { EmployeesData } from '@common/models/employeesData.model';
import { EmployeeAddUpdateData } from '@common/models/employeeAddUpdateData.model';
import { EmployeeAddResponse } from '@common/models/employeeAddResponse.model';
import { QueryParameters } from '@common/models/queryParameters.model';
import { QueryParametersStringified } from '@common/models/queryParametersStringified.model';

@Injectable()
export class EmployeeService {
  constructor(
    private http: HttpClient,
    public authService: AuthService,
  ) {}

  addEmployee(addEmployeeData: EmployeeAddUpdateData): Observable<EmployeeAddResponse> {
    const endpoint = environment.endpoints.employeeAdd;
    const accessToken = this.authService.getAccessToken();
    const companyKey = this.authService.getCompanyKey();

    return this.http.post<EmployeeAddResponse>(
      `${endpoint}${companyKey}/`,
      addEmployeeData,
      {
        headers: new HttpHeaders()
          .set('Authorization', `Bearer ${accessToken}`)
          .set('language', navigator.language),
      },
    );
  }

  getEmployees(queryParameters: QueryParameters): Observable<EmployeesData> {
    const endpoint = environment.endpoints.employees;
    const accessToken = this.authService.getAccessToken();
    const companyKey = this.authService.getCompanyKey();

    const params: QueryParametersStringified = {
      query: queryParameters.query,
      orderBy: queryParameters.orderBy,
      sortOrder: queryParameters.sortOrder,
      page: queryParameters.page.toString(),
    };

    return this.http.get<EmployeesData>(
      `${endpoint}${companyKey}/`,
      {
        params,
        headers: new HttpHeaders()
          .set('Authorization', `Bearer ${accessToken}`)
          .set('language', navigator.language),
      },
    );
  }

  getEmployeeDetails(employeeKey: string): Observable<EmployeeDetails> {
    const endpoint = environment.endpoints.employeeDetails;
    const accessToken = this.authService.getAccessToken();
    const companyKey = this.authService.getCompanyKey();

    return this.http.get<EmployeeDetails>(
      `${endpoint}${companyKey}/${employeeKey}/`,
      {
        headers: new HttpHeaders()
          .set('Authorization', `Bearer ${accessToken}`)
          .set('language', navigator.language),
      },
    );
  }

  editEmployee(employeeKey: string, employeeUpdateData: EmployeeAddUpdateData): Observable<null> {
    const endpoint = environment.endpoints.employeeUpdate;
    const accessToken = this.authService.getAccessToken();
    const companyKey = this.authService.getCompanyKey();

    return this.http.post<null>(
      `${endpoint}${companyKey}/${employeeKey}/`,
      employeeUpdateData,
      {
        headers: new HttpHeaders()
          .set('Authorization', `Bearer ${accessToken}`)
          .set('language', navigator.language),
      },
    );
  }

  deleteEmployee(employeeKey: string): Observable<null> {
    const endpoint = environment.endpoints.employeeDelete;
    const accessToken = this.authService.getAccessToken();
    const companyKey = this.authService.getCompanyKey();

    return this.http.delete<null>(
      `${endpoint}${companyKey}/${employeeKey}/`,
      {
        headers: new HttpHeaders()
          .set('Authorization', `Bearer ${accessToken}`)
          .set('language', navigator.language),
      },
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/common/services/EmployeeService/EmployeeService.ts